/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { userSchema } from "./userSchema.ts";
import { z } from "zod";

export const contactSchema = z.object({
      "id": z.string(),
  "phone": z.string().optional(),
  "mobile": z.string().optional(),
  "user": z.lazy(() => userSchema).optional()
      })